import {ProjectReferenceCompanyVisibility} from '@frontend/shared-api';

export interface VisibilityOption {
  key: string;
  value: ProjectReferenceCompanyVisibility;
}

export const ANONYMIZED_COMPANY_NAME = '***';

export const VISIBILITY_OPTIONS: VisibilityOption[] = [
  {
    key: 'provider.tenderResponse.projectReferences.visibility.named',
    value: ProjectReferenceCompanyVisibility.NAMED,
  },
  {
    key: 'provider.tenderResponse.projectReferences.visibility.anonymized',
    value: ProjectReferenceCompanyVisibility.ANONYMIZED,
  },
];
